// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1001;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  transition: opacity 0.3s ease, transform 0.3s ease;
  background-color: #ffffff !important;
}
.chat-fab .chat-fab-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
  transform: scale(2);
  transform-origin: center;
}
.chat-fab.hidden {
  opacity: 0;
  pointer-events: none;
  transform: scale(0.8);
}
.chat-fab:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
}

.chat-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 550px;
  height: 100vh;
  background-color: white;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2100; /* Highest overlay level to ensure visibility across all pages */
  overflow: hidden;
}
.chat-panel.open {
  transform: translateX(0);
}

.chat-panel-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #1976d2;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.chat-header .header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.chat-header .header-content h3 {
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 500;
}
.chat-header .header-content .nora-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.chat-header .header-content .nora-icon--2x {
  transform: scale(2);
  transform-origin: left center;
}
.chat-header .header-content .nora-icon--2x + h3 {
  margin-left: 20px;
}
.chat-header .header-actions {
  display: flex;
  gap: 4px;
}
.chat-header .header-actions button {
  color: white;
}

.session-list {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  z-index: 10;
  display: flex;
  flex-direction: column;
}
.session-list.visible {
  transform: translateX(0);
}
.session-list .session-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}
.session-list .session-list-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}
.session-list mat-nav-list {
  overflow-y: auto;
  flex: 1;
}
.session-list .session-item {
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}
.session-list .session-item:hover {
  background-color: #f5f5f5;
}
.session-list .empty-sessions {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
  padding: 24px;
}
.session-list .empty-sessions mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  opacity: 0.3;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: white;
  scroll-behavior: smooth;
}
.chat-messages .history-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: #e3f2fd;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
  color: #1565c0;
  font-size: 14px;
}
.chat-messages .history-notice mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #1976d2;
}
.chat-messages .loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #757575;
}
.chat-messages .loading-indicator p {
  margin-top: 16px;
}
.chat-messages .welcome-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: #616161;
  padding: 24px;
}
.chat-messages .welcome-message .welcome-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  object-fit: contain;
}
.chat-messages .welcome-message h4 {
  margin: 0 0 8px 0;
  color: #212121;
}
.chat-messages .welcome-message p {
  margin: 0 0 24px 0;
  color: #757575;
}
.chat-messages .welcome-message .example-queries {
  width: 100%;
  margin-top: 16px;
}
.chat-messages .welcome-message .example-queries .example-label {
  font-size: 12px;
  font-weight: 500;
  color: #9e9e9e;
  margin-bottom: 8px;
}
.chat-messages .welcome-message .example-queries mat-chip-listbox {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-messages .welcome-message .example-queries mat-chip-listbox mat-chip-option {
  cursor: pointer;
  font-size: 13px;
}
.chat-messages .welcome-message .example-queries mat-chip-listbox mat-chip-option:hover {
  background-color: #e3f2fd;
}
.chat-messages .typing-indicator-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}
.chat-messages .error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #ffebee;
  color: #c62828;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}
.chat-messages .error-message mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

@media (max-width: 768px) {
  .chat-fab {
    bottom: 16px;
    right: 16px;
  }
  .chat-panel {
    width: 100vw;
  }
  .chat-panel.open {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/chat/chat-container/chat-container.component.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,0CAAA;EACA,kDAAA;EACA,oCAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;AAGE;EACE,UAAA;EACA,oBAAA;EACA,qBAAA;AADJ;AAIE;EACE,2CAAA;AAFJ;;AAOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uDAAA;EACA,aAAA,EAAA,gEAAA;EACA,gBAAA;AAJF;AAME;EACE,wBAAA;AAJJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AANF;;AAUA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPJ;AASI;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAPN;AAUI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AARN;AAWI;EACE,mBAAA;EACA,6BAAA;AATN;AAYI;EACE,iBAAA;AAVN;AAcE;EACE,aAAA;EACA,QAAA;AAZJ;AAcI;EACE,YAAA;AAZN;;AAiBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAdF;AAgBE;EACE,wBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAfJ;AAiBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAfN;AAmBE;EACE,gBAAA;EACA,OAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gCAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;AAsBE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AApBJ;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AApBN;;AAyBA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAtBF;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtBN;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAxBJ;AA0BI;EACE,gBAAA;AAxBN;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AA1BJ;AA4BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA1BN;AA6BI;EACE,iBAAA;EACA,cAAA;AA3BN;AA8BI;EACE,kBAAA;EACA,cAAA;AA5BN;AA+BI;EACE,WAAA;EACA,gBAAA;AA7BN;AA+BM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7BR;AAgCM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9BR;AAgCQ;EACE,eAAA;EACA,eAAA;AA9BV;AAgCU;EACE,yBAAA;AA9BZ;AAqCE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AApCJ;AAsCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApCN;;AA0CA;EACE;IACE,YAAA;IACA,WAAA;EAvCF;EA0CA;IACE,YAAA;EAxCF;EA0CE;IACE,wBAAA;EAxCJ;AACF","sourcesContent":["// Chat FAB button (bottom right)\n.chat-fab {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 1001;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  background-color: #ffffff !important;\n\n  .chat-fab-icon {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    display: block;\n    transform: scale(2);\n    transform-origin: center;\n  }\n\n  &.hidden {\n    opacity: 0;\n    pointer-events: none;\n    transform: scale(0.8);\n  }\n\n  &:hover {\n    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);\n  }\n}\n\n// Chat panel container - docked to right side\n.chat-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 550px;\n  height: 100vh;\n  background-color: white;\n  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);\n  z-index: 2100; /* Highest overlay level to ensure visibility across all pages */\n  overflow: hidden;\n\n  &.open {\n    transform: translateX(0);\n  }\n}\n\n// Panel content wrapper\n.chat-panel-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: #1976d2;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    h3 {\n      margin: 0;\n      color: white;\n      font-size: 18px;\n      font-weight: 500;\n    }\n\n    .nora-icon {\n      width: 28px;\n      height: 28px;\n      object-fit: contain;\n    }\n\n    .nora-icon--2x {\n      transform: scale(2);\n      transform-origin: left center;\n    }\n\n    .nora-icon--2x + h3 {\n      margin-left: 20px;\n    }\n  }\n\n  .header-actions {\n    display: flex;\n    gap: 4px;\n\n    button {\n      color: white;\n    }\n  }\n}\n\n.session-list {\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: white;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n\n  &.visible {\n    transform: translateX(0);\n  }\n\n  .session-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    border-bottom: 1px solid #e0e0e0;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 500;\n    }\n  }\n\n  mat-nav-list {\n    overflow-y: auto;\n    flex: 1;\n  }\n\n  .session-item {\n    cursor: pointer;\n    border-bottom: 1px solid #f5f5f5;\n\n    &:hover {\n      background-color: #f5f5f5;\n    }\n  }\n\n  .empty-sessions {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #9e9e9e;\n    padding: 24px;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      margin-bottom: 16px;\n      opacity: 0.3;\n    }\n  }\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  background-color: white;\n  scroll-behavior: smooth;\n\n  .history-notice {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    margin-bottom: 16px;\n    background-color: #e3f2fd;\n    border-left: 4px solid #1976d2;\n    border-radius: 4px;\n    color: #1565c0;\n    font-size: 14px;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      color: #1976d2;\n    }\n  }\n\n  .loading-indicator {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #757575;\n\n    p {\n      margin-top: 16px;\n    }\n  }\n\n  .welcome-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n    color: #616161;\n    padding: 24px;\n\n    .welcome-icon {\n      width: 72px;\n      height: 72px;\n      margin-bottom: 16px;\n      object-fit: contain;\n    }\n\n    h4 {\n      margin: 0 0 8px 0;\n      color: #212121;\n    }\n\n    p {\n      margin: 0 0 24px 0;\n      color: #757575;\n    }\n\n    .example-queries {\n      width: 100%;\n      margin-top: 16px;\n\n      .example-label {\n        font-size: 12px;\n        font-weight: 500;\n        color: #9e9e9e;\n        margin-bottom: 8px;\n      }\n\n      mat-chip-listbox {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        mat-chip-option {\n          cursor: pointer;\n          font-size: 13px;\n\n          &:hover {\n            background-color: #e3f2fd;\n          }\n        }\n      }\n    }\n  }\n\n  .typing-indicator-container {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 16px;\n  }\n\n  .error-message {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background-color: #ffebee;\n    color: #c62828;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    font-size: 14px;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n}\n\n@media (max-width: 768px) {\n  .chat-fab {\n    bottom: 16px;\n    right: 16px;\n  }\n\n  .chat-panel {\n    width: 100vw;\n    \n    &.open {\n      transform: translateX(0);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
